import React, { useEffect, useState } from "react";
import { Plus, Trash2, BookOpen } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export const DISH_CATS = ["Çorba", "Ana Yemek", "Yardımcı", "Salata", "Tatlı", "İçecek"];

export default function DishLibrary({ onPick, activeCell }) {
  const [dishes, setDishes] = useState([]);
  const [name, setName] = useState("");
  const [cat, setCat] = useState("Ana Yemek");
  const [q, setQ] = useState("");
  const load = () => api.get("/dishes").then((r) => setDishes(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!name.trim()) return;
    try { await api.post("/dishes", { name: name.trim(), category: cat }); setName(""); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const del = async (id) => { await api.delete(`/dishes/${id}`); load(); };
  const shown = dishes.filter((d) => !q || d.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="rounded-xl border border-border bg-card p-4 space-y-3" data-testid="dish-library">
      <div className="flex items-center justify-between">
        <h3 className="font-heading font-semibold flex items-center gap-2"><BookOpen className="h-4 w-4 text-primary" /> Yemek Kütüphanesi</h3>
        <span className="text-xs text-muted-foreground" data-testid="dish-active-cell">{activeCell ? `${activeCell.ds.slice(8)}. gün · ${activeCell.idx + 1}. alan` : "Önce bir alana tıklayın"}</span>
      </div>
      <div className="flex gap-2">
        <Input placeholder="Yeni yemek adı" value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} data-testid="dish-name-input" className="h-9" />
        <Select value={cat} onValueChange={setCat}>
          <SelectTrigger className="h-9 w-32" data-testid="dish-cat-select"><SelectValue /></SelectTrigger>
          <SelectContent>{DISH_CATS.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
        <Button size="sm" onClick={add} data-testid="dish-add-btn" className="h-9 gap-1"><Plus className="h-4 w-4" /> Ekle</Button>
      </div>
      <Input placeholder="Ara…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="dish-search" className="h-9" />
      <div className="max-h-72 overflow-y-auto space-y-3" data-testid="dish-list">
        {shown.length === 0 && <div className="text-sm text-muted-foreground text-center py-4" data-testid="dish-empty">Kayıtlı yemek yok — yukarıdan ekleyin</div>}
        {DISH_CATS.filter((c) => shown.some((d) => d.category === c)).map((c) => (
          <div key={c}>
            <div className="text-[10px] uppercase tracking-wider text-muted-foreground mb-1">{c}</div>
            <div className="flex flex-wrap gap-1.5">
              {shown.filter((d) => d.category === c).map((d) => (
                <span key={d.id} className="group inline-flex items-center rounded-full border border-border bg-background text-xs">
                  <button onClick={() => onPick(d.name)} disabled={!activeCell} data-testid={`dish-pick-${d.id}`} className="px-2.5 py-1 hover:text-primary disabled:opacity-50">{d.name}</button>
                  <button onClick={() => del(d.id)} data-testid={`dish-delete-${d.id}`} className="pr-2 text-muted-foreground/50 hover:text-destructive"><Trash2 className="h-3 w-3" /></button>
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
